import "./styles.css";
import { MenuContainer } from "./MenuContainer/Index";
import { MenuOption } from "./MenuOption/Index";
import { ReactComponent as Mapa } from "../../../assets/svg/icons/mapa.svg";
import { ReactComponent as Dados } from "../../../assets/svg/icons/dados.svg";
import { ReactComponent as Animais } from "../../../assets/svg/icons/animais.svg";
import { ReactComponent as LogoPastejo } from "../../../assets/svg/logo/logoPastejoV2.svg";
import { ReactComponent as LogoIcon } from "../../../assets/svg/logo/iconV2.svg";
import { CSSProperties, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Constants from "../../../constants/Index";
import { useFilter } from "../../../hooks/useFilter";
import jwt_decode from "jwt-decode";
import { logout } from "../../../services/auth";
import { IOptionsSideBarLinks } from "../../../contexts/FilterContext";
import { ButtonWithChildren } from "../../Buttons/ButtonWithChildren/Index";
import { ReactComponent as HatIcon } from "../../../assets/svg/icons/hat.svg";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import { TasksModals } from "../../Tasks/TasksModals/Index";
import { SubMenuOption } from "./SubMenuOption";
import { FiMenu, FiX } from "react-icons/fi";
import { ReactComponent as ChevronLeft } from "../../../assets/svg/icons/leftChevron.svg";
// import { FixInventory } from "../../Modal/Inventory";

const SIDEBAR_LINK_THEME = {
  selected: {
    color: "#ffffff",
  },
  normal: {
    color: "#999999",
  },
  disabled: {
    color: "#999999",
    cursor: "not-allowed",
  },
};

const BUTTON_MAP_THEME = {
  selected: {
    background: "#57ce71",
  },
  normal: {
    background: "#ffffff",
  },
};

enum SIDEBAR_NAMES {
  INVENTORY = "INVENTORY",
  MANAGER_SYSTEM = "MANAGER_SYSTEM",
  LOGOUT = "LOGOUT",
}

interface SideBarLinkComponentProps {
  sideBarName: IOptionsSideBarLinks;
  label: string;
  href?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  disabled?: boolean;
}

export function SideBar() {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const {
    sideBarOptionSelected,
    setSideBarOptionSelected,
    systemManager,
    setSystemManager,
  } = useFilter();
  const [permission, setPermission] = useState<boolean>(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const { setShowTasklistModal } = useTaskCreation();

  // Detectar se é mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Disparar evento customizado para sincronizar com o template
  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent("sidebarToggle", { detail: { isOpen } }),
    );
  }, [isOpen]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const collapseSidebar = () => {
    if (isMobile && isOpen) {
      setIsOpen(false);
    }
  };

  // Escutar evento para comprimir sidebar quando MenuOption for clicado
  useEffect(() => {
    const handleCollapseSidebar = () => {
      collapseSidebar();
    };

    window.addEventListener("collapseSidebar", handleCollapseSidebar);

    return () => {
      window.removeEventListener("collapseSidebar", handleCollapseSidebar);
    };
  }, [isMobile, isOpen]);

  const isCollapsed = !isOpen;

  function handleSideBarLink(sideBarName: IOptionsSideBarLinks, href?: string) {
    setSideBarOptionSelected(sideBarName);
    if (href) navigate(href);
  }

  function userLogout() {
    logout();
  }

  const SideBarLinkComponent = ({
    href,
    sideBarName,
    onClick,
    label,
    disabled = false,
  }: SideBarLinkComponentProps) => {
    return (
      <div className="sideBar_footer">
        <span
          style={
            disabled
              ? SIDEBAR_LINK_THEME.disabled
              : sideBarOptionSelected == sideBarName
                ? SIDEBAR_LINK_THEME.selected
                : SIDEBAR_LINK_THEME.normal
          }
          onClick={(event) => {
            if (onClick) onClick(event);
            if (systemManager) setSystemManager(null);
            handleSideBarLink(sideBarName, href);
            navigate("/mapadepastos");
            collapseSidebar();
          }}
        >
          {!isCollapsed && label}
        </span>
      </div>
    );
  };

  useEffect(() => {
    try {
      const decode: any = jwt_decode(token || " ");

      switch (decode.ROLE) {
        case "MASTER":
          setPermission(true);
          break;
        case "GERENTE":
          setPermission(true);
          break;
        default:
          setPermission(false);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  var packageJsonInfo = require("../../../../package.json");

  return (
    <>
      <div
        className={`${isOpen ? "SideBarShow" : "SideBarHide"} ${isMobile ? "SideBarMobile" : ""} ${isCollapsed ? "SideBarCollapsed" : ""} no-print`}
      >
        {/* Botão toggle para todos os dispositivos */}
        <button
          className={`sidebar__toggle ${isOpen ? "sidebar__toggle--expanded" : "sidebar__toggle--collapsed"}`}
          onClick={toggleSidebar}
        >
          <ChevronLeft />
        </button>

        <div className="sideBar_header_buttons">
          <Link
            style={
              isCollapsed && !isMobile
                ? { background: "transparent" }
                : sideBarOptionSelected === "MAPA"
                  ? BUTTON_MAP_THEME.selected
                  : BUTTON_MAP_THEME.normal
            }
            onClick={() => {
              setSideBarOptionSelected("MAPA");
            }}
            to={"/mapadepastos"}
          >
            <div className="sideBar_header">
              {isCollapsed && !isMobile ? (
                <LogoIcon className="sideBar_header--icon" />
              ) : (
                <LogoPastejo height={50} />
              )}
            </div>
          </Link>
        </div>

        <MenuContainer
          icon={Dados}
          title="Relatórios"
          borderColor="#57ce71"
          isCollapsed={isCollapsed}
          onExpandSidebar={toggleSidebar}
        >
          <SubMenuOption
            title="Mapa de Gado"
            basePath={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP}
            to={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_GENERAL}
            onClicked={() => {
              setSideBarOptionSelected("DASHBOARD");
            }}
          >
            <MenuOption
              name={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_GENERAL}
              to={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_GENERAL}
              title={"Geral"}
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_BATCHES}
              to={Constants.PADDOCKS_MAP_DASHBOARD_CATTLE_MAP_BATCHES}
              title={"Lotes"}
            />
          </SubMenuOption>

          <SubMenuOption
            title={"Suplementação"}
            basePath={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION}
            to={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONTROL}
            onClicked={() => {
              setSideBarOptionSelected("DASHBOARD");
            }}
          >
            <MenuOption
              name={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONTROL}
              to={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONTROL}
              title="Controle de estoque"
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_REPORT}
              to={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_REPORT}
              title="Análise de consumo"
            />
            <MenuOption
              name={
                Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONSUMPTION
              }
              to={Constants.PADDOCKS_MAP_DASHBOARD_SUPPLEMENTATION_CONSUMPTION}
              title="Consumo por mês"
            />
          </SubMenuOption>

          <SubMenuOption
            title={"Manejo de Pasto"}
            basePath={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT}
            to={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_GENERAL}
            onClicked={() => {
              setSideBarOptionSelected("DASHBOARD");
            }}
          >
            <MenuOption
              name={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_GENERAL}
              to={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_GENERAL}
              title={"Geral"}
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_MICROAREA}
              to={Constants.PADDOCKS_MAP_DASHBOARD_MANAGEMENT_MICROAREA}
              title={"Por grupo de manejo"}
            />
          </SubMenuOption>

          <MenuOption
            name={Constants.PADDOCKS_MAP_DASHBOARD_CARBON}
            to={Constants.PADDOCKS_MAP_DASHBOARD_CARBON}
            title={"Carbono"}
            onClicked={() => {
              setSideBarOptionSelected("DASHBOARD");
            }}
          />

          <MenuOption
            name={Constants.PADDOCKS_MAP_DASHBOARD_EXPORT}
            to={Constants.PADDOCKS_MAP_DASHBOARD_EXPORT}
            title={"Relatórios"}
            onClicked={() => {
              setSideBarOptionSelected("DASHBOARD");
            }}
          />
        </MenuContainer>

        <MenuContainer
          icon={Animais}
          title="Manejo de Pasto"
          borderColor="#62B8AE"
          isCollapsed={isCollapsed}
          onExpandSidebar={toggleSidebar}
        >
          <SubMenuOption
            title={"Lotação"}
            basePath={Constants.PADDOCKS_MAP_CAPACITY}
            to={Constants.PADDOCKS_MAP_CAPACITY_IMMEDIATE}
            onClicked={() => {
              setSideBarOptionSelected("MAPA");
            }}
          >
            <MenuOption
              name={Constants.PADDOCKS_MAP_CAPACITY_IMMEDIATE}
              to={Constants.PADDOCKS_MAP_CAPACITY_IMMEDIATE}
              title="Lotação instantânea"
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_CAPACITY_AVAREGE}
              to={Constants.PADDOCKS_MAP_CAPACITY_AVAREGE}
              title="Lotação média"
            />
          </SubMenuOption>

          <MenuOption
            name={Constants.PADDOCKS_MAP_PADDOCK_TIME}
            to={Constants.PADDOCKS_MAP_PADDOCK_TIME}
            title="Dias de ocupação e descanso"
            onClicked={() => {
              setSideBarOptionSelected("MAPA");
            }}
          />
          <SubMenuOption
            title={"Manejo"}
            basePath={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT}
            to={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_TYPE}
            onClicked={() => {
              setSideBarOptionSelected("MAPA");
            }}
          >
            <MenuOption
              name={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_TYPE}
              to={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_TYPE}
              title="Tipo de manejo"
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_HEIGHT}
              to={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_HEIGHT}
              title="Altura"
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_RATE}
              to={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_RATE}
              title="Nota"
            />
            <MenuOption
              name={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_DAY}
              to={Constants.PADDOCKS_MAP_PASTURE_MANAGEMENT_DAY}
              title="Dias"
            />
          </SubMenuOption>
        </MenuContainer>

        <div className="footerContent">
          {permission && (
            <>
              {!isCollapsed && (
                <div className="createTask_buttonWrapper">
                  <ButtonWithChildren
                    theme={"info"}
                    onClick={() => {
                      setShowTasklistModal(true);
                      collapseSidebar();
                    }}
                  >
                    <div className="buttonWithChildren--content-inline button__createTask">
                      <HatIcon />
                      <h6>Criar tarefas</h6>
                    </div>
                  </ButtonWithChildren>
                </div>
              )}
              {isCollapsed && (
                <div className="createTask_buttonWrapper--collapsed">
                  <button
                    className="sidebar__icon-button"
                    onClick={() => {
                      setShowTasklistModal(true);
                      collapseSidebar();
                    }}
                    title="Criar tarefas"
                  >
                    <HatIcon />
                  </button>
                </div>
              )}
              <SideBarLinkComponent
                sideBarName={SIDEBAR_NAMES.INVENTORY}
                label="Realizar inventário"
              />
              <SideBarLinkComponent
                sideBarName={SIDEBAR_NAMES.MANAGER_SYSTEM}
                label="Gerenciar sistema"
              />
            </>
          )}
          <SideBarLinkComponent
            onClick={userLogout}
            sideBarName={SIDEBAR_NAMES.LOGOUT}
            label="Sair"
          />
        </div>
        {!isCollapsed && (
          <>
            <div className="divider" style={{ marginTop: 20 }} />
            <div className="sideBar_footer_version">
              <span>Versão {packageJsonInfo.version}</span>
            </div>
          </>
        )}
      </div>
      <TasksModals />
      {/* <FixInventory /> */}
    </>
  );
}
